var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "alpheios-wordlist-download-confirmation alpheios-notification-area__notification alpheios-notification-area__notification--important",
    },
    [
      _c("div", { staticClass: "alpheios-notification-area__msg" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.l10n.getText("WORDLIST_DOWNLOAD_NOTICE")) +
            "\n\n      "
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showProgress,
                expression: "showProgress",
              },
            ],
            staticClass: "alpheios-wordlist-download-confirmation-loading",
          },
          [
            _c("progress-bar", {
              attrs: { text: _vm.l10n.getText("PLACEHOLDER_LEX_DATA_LOADING") },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "alpheios-wordlist-download-confirmation__buttons alpheios-notification-area__control",
        },
        [
          _c(
            "alph-tooltip",
            {
              attrs: {
                tooltipText: _vm.l10n.getText("WORDLIST_TOOLTIP_DOWNLOAD", {
                  lang: _vm.languageCode,
                }),
                tooltipDirection: "bottom-wide",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "alpheios-button-primary",
                  on: {
                    click: function ($event) {
                      return _vm.downloadList()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.l10n.getText("WORDLIST_DOWNLOAD_BUTTON")) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "alpheios-wordlist-download-with-filters alpheios-checkbox-block",
              attrs: { "data-alpheios-ignore": "all" },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.downloadWithFilter,
                    expression: "downloadWithFilter",
                  },
                ],
                attrs: { id: _vm.downloadFilterId, type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.downloadWithFilter)
                    ? _vm._i(_vm.downloadWithFilter, null) > -1
                    : _vm.downloadWithFilter,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.downloadWithFilter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.downloadWithFilter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.downloadWithFilter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.downloadWithFilter = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: _vm.downloadFilterId } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.l10n.getText("WORDLIST_DOWNLOAD_FILTERING_CHECK")
                    ) +
                    "\n            "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "alpheios-wordlist-download-for-flashcards alpheios-checkbox-block",
              attrs: { "data-alpheios-ignore": "all" },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.downloadForFlashcards,
                    expression: "downloadForFlashcards",
                  },
                ],
                attrs: { id: _vm.downloadFlashcardsId, type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.downloadForFlashcards)
                    ? _vm._i(_vm.downloadForFlashcards, null) > -1
                    : _vm.downloadForFlashcards,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.downloadForFlashcards,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.downloadForFlashcards = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.downloadForFlashcards = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.downloadForFlashcards = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: _vm.downloadFlashcardsId } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.l10n.getText("WORDLIST_DOWNLOAD_FLASHCARDS_CHECK")
                    ) +
                    "\n            "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.featureOptions
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.downloadForFlashcards,
                      expression: "downloadForFlashcards",
                    },
                  ],
                  staticClass: "alpheios-wordlist-download-amount",
                  attrs: { "data-alpheios-ignore": "all" },
                },
                [_c("p", [_vm._v(_vm._s(this.maxFlashCardItemsNote))])]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "alpheios-notification-area__close-btn",
          on: {
            click: function ($event) {
              return _vm.cancelDownloadList()
            },
          },
        },
        [_c("close-icon")],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }